import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { SelectProps } from 'antd';
import { generateOptions } from './helper';

export const generate = (
  props?: Partial<IFormFieldSchema<SelectProps>>
): IFormFieldSchema<SelectProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Select',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormSelect,
    'x-validator': [],
    enum: generateOptions(props),
    'x-component-props': {
      placeholder: props?.['x-component-props']?.placeholder,
      allowClear: props?.['x-component-props']?.allowClear ?? false,
      mode: props?.['x-component-props']?.mode,
      size: props?.['x-component-props']?.size,
      disabled: props?.['x-component-props']?.disabled,
      ...props?.['x-component-props'],
    },
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
